(function () {
  'use strict';

  var bar = document.querySelector('[data-nked-sticky-cta]');
  if (!bar) return;

  // Trigger element: the Customer Reviews section.
  var reviews = document.querySelector('.nked-reviews');
  if (!reviews) return;

  var ticking = false;

  function apply() {
    ticking = false;

    // Show once the top of the reviews section has scrolled into the lower
    // part of the viewport; hide again when the visitor scrolls back up above it.
    var top = reviews.getBoundingClientRect().top;
    var trigger = window.innerHeight * 0.9;

    if (top <= trigger) {
      if (!bar.classList.contains('is-visible')) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      }
    } else if (bar.classList.contains('is-visible')) {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(apply);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  apply();

  // The button links to /products/nked-glp-baddie?view=pdp (the PDP page, top).
  // Everywhere else (homepage included) the browser just navigates there.
  // Only when already ON the PDP view do we intercept and scroll to the top,
  // to avoid a no-op same-URL nav. NB: the homepage also renders .nked-buybox,
  // so detection must key off the ?view=pdp URL, not that element.
  var onPdp =
    window.location.pathname.indexOf('/products/nked-glp-baddie') !== -1 &&
    /[?&]view=pdp\b/.test(window.location.search);

  if (onPdp) {
    var btns = bar.querySelectorAll('[data-nked-sticky-cta-btn]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }
})();
